import React, { useEffect, useState } from "react";
import SC from "./style";
import { Breadcrumbs, InnoTable } from "InnoUI/components";
import { useLocation, useNavigate } from "react-router";
import { apiGet } from "api/callApi";

const SystemPrompts = ({ popupState }) => {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "System Prompts", href: "/admin-settings/syastem-prompts" },
  ];
  console.table(data, "op");

  const getAllPrompts = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet("/v1/getallprompts", false);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAllPrompts();
  }, []);

  const onAddDataCallback = () => {
    setOpen(true);
  };

  const onRowClick = (data) => {
    setOpen(true);
  };

  const handlelevelClick = (data) => {
    const newData = {
      id: data.prompt_id,
      title: data.title,
    };
    navigate(`/admin-settings/system-prompts/update-prompts`, {
      state: { newData },
    });
  };

  const renderText = (value) => <SC.ValueSpan>{value}</SC.ValueSpan>;

  const subColumnData = [
    {
      title: "Name",
      dataIndex: "title",
      render: renderText,
    },

    {
      title: "Revisions",
      dataIndex: "current_revision_no",
      render: renderText,
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    sno: false,
    addNew: false,
    // pagination: false,
    search: false,
    action: false,
    divBorder: false,
    searchPlaceholder: "Search by Name and Template",
  };

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href);
    }
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={location.pathname}
        onClick={handleBreadcrumbClick}
      />
      <SC.BodyContainer>
        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            loading={isLoading}
            padding="10px"
            column={subColumnData}
            data={data}
            tableKey="Syatem Prompts"
            ComponnentName="Project"
            searchKeys={["propertyName", "displayTemplateName"]}
            onRowClickCallback={onRowClick}
            onAddDataCallback={onAddDataCallback}
            onRow={(record) => ({
              onClick: (event) => {
                setTimeout(() => {
                  if (!document.querySelector(".ant-image-preview-mask")) {
                    handlelevelClick(record);
                  }
                }, 100);
              },
            })}
          />
        </SC.Container>
      </SC.BodyContainer>
    </>
  );
};

export default SystemPrompts;
